<template>
  <div class="md-table-cell-container">
    <md-button
      class="md-just-icon md-danger md-simple table-action"
      @click.native="confirmUnassign"
    >
      <md-tooltip md-direction="top">{{ $t("class.unassign") }}</md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["item"],
  data() {
    return {};
  },
  inject: ["unassignStudents"],
  methods: {
    confirmUnassign() {
      Swal.fire({
        title: this.$t("class.unassign_student") + this.item.username,
        text: this.$t("class.are_you_sure_unassign_this_student"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.unassignStudents([this.item]);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
